var EngraveModal = {};
EngraveModal.loadModal = function (product, settings) {
  settings = settings || {};
  if (EngraveModal.$element) {
    EngraveModal.applyEditValues(settings);
    EngraveModal.$element.popup('show');
    return;
  }
  jQuery.ajax({
    url: "/product/" + product._id + "/engrave",
    method: "get",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      $("body").append(resp.html);
      EngraveModal.$element = $('#engrave_modal');
      EngraveModal.applyEditValues(settings);
      EngraveModal.$element.popup('show');
      EngraveModal.$element.find("form button").click(function (evt) {
        evt.preventDefault();
        var engraveForm = {};
        $(document.forms.engraveForm).serializeArray().forEach(function (fv) {
          engraveForm[fv.name] = fv.value
        });
        if (engraveForm.place && engraveForm.engrave && engraveForm.engraveText) {
          var item = {
            type: "engrave",
            product: product._id,
            version: product.version,
            qty: 1,
            metadata: {
              place: engraveForm.place,
              font: engraveForm.engrave,
              text: engraveForm.engraveText
            }
          };
          if (settings.item && settings.item._id) {
            item._id = settings.item._id;
          }
          settings.onAddToCart && settings.onAddToCart(item);
          EngraveModal.$element.popup("hide");
        }
      });
    }
  });
};

EngraveModal.applyEditValues = function (settings) {
  if (settings.edit) {
    if (settings.item.metadata && settings.item.metadata.place === "box") {
      $(EngraveModal.$element.find("form input[name=place]")[1]).attr('checked', 'checked');
    }
    EngraveModal.$element.find("form textarea").val(settings.item.metadata.text);
    EngraveModal.$element.find("form input[value='" + settings.item.metadata.font + "']").attr('checked', 'checked');
  }
};